export default {
  en: {
    oneTokenPrice: 'INSTANT One Token Price',
    withdrawToUSDT: 'Withdraw to USDT',
    usdtTotal: 'USDT Total',
    usdtTotalPlaceholder: 'How much USDT you want to withdrawl?',
    FixTotal: 'INSTANT Token Total',
    FixTotalPlaceholder: 'How much INSTANT you want to withdrawl?',
    usdtWallet: 'Your USDT Wallet',
    usdtWalletPlaceholder: 'Your USDT Wallet Address',
    usdtGetTotal: 'Total USDT you will get',
    usdtGetTotalPlaceholder: 'Total USDT you will get',
    totalWithCommission: 'TOTAL WITH BLOCKCHAIN COMMISSION FOR TRANSACTION',
    exchangeUSDToFIX: 'Exchange USD to INSTANT One Token',
    usdTotal: 'USD Total',
    usdTotalPlaceholder: 'How much USD you want to exchange?',
    totalFIXOneWillGet: 'Total INSTANT One you will get',
    totalFIXOneWillGetPlaceholder: 'INSTANT One Token Total',
    totalWithUSDCommission: 'TOTAL WITH 1% COMMISSION',
    exchange: 'Exchange',
    confirmData: 'Please confirm your data',
    confirm: 'Confirm',
    partnershipTransactions: 'Partnership Account Transactions',
    hoursProceed: 'Your withdrawal request will be processed according to the rules for a maximum of 24 hours',
    partnerName: 'Partner Name',
    userLevel: 'User level',
    verificationCode: 'Enter your verification code from Email',
    enterCode: 'Enter code',
    resendCode: 'Resend code',
    submitWithdraws: 'Submit Withdraws',
    submitInstruction: 'Enter your Transaction HASH  You can find your transaction ID in your wallet (Trust Wallet, Metamask and etc)',
    availableBalance: 'Available balance',
    choiceNetwork: 'Select Network',
    partnership: 'Partnership',
    exchangeVideo: 'https://www.youtube.com/embed/vdzMx21XiTU',
  },
  ru: {
    oneTokenPrice: 'INSTANT One Token Price',
    withdrawToUSDT: 'Вывод на USDT',
    usdtTotal: 'USDT Всего',
    usdtTotalPlaceholder: 'Сколько USDT Вы хотите вывести?',
    FixTotal: 'INSTANT Token Итого',
    FixTotalPlaceholder: 'Сколько INSTANT вы хотите вывести?',
    usdtWallet: 'Ваш USDT Кошелёк',
    usdtWalletPlaceholder: 'Ваш адрес USDT Кошелька',
    usdtGetTotal: 'Итого USDT Вы получите',
    usdtGetTotalPlaceholder: 'Итого USDT Вы получите',
    totalWithCommission: 'ИТОГО С УЧЕТОМ КОМИССИИ БЛОКЧЕЙНА ЗА ТРАНЗАКЦИЮ ',
    exchangeUSDToFIX: 'Обменять USD на INSTANT One Токен',
    usdTotal: 'USD Всего',
    usdTotalPlaceholder: 'Сколько USD Вы хотите обменять?',
    totalFIXOneWillGet: 'Всего INSTANT One Токенов Вы получите',
    totalFIXOneWillGetPlaceholder: 'INSTANT One Токенов Всего',
    totalWithUSDCommission: 'ИТОГО С 1% КОМИССИЕЙ',
    exchange: 'Обменять',
    confirmData: 'Пожалуйста, Подтвердите Ваши данные!',
    confirm: 'Подтвердить',
    partnershipTransactions: 'Транзакции Партнёрского счёта',
    hoursProceed: 'Ваш запрос на вывод средств будет обрабатываться в соответствии с правилами в течение максимум 24 часов',
    partnerName: 'Имя партнера',
    userLevel: 'Уровень',
    verificationCode: 'Введите проверочный код из электронной почты',
    enterCode: 'Введите код',
    resendCode: 'Отправить код повторно',
    submitWithdraws: 'Подтверждение вывода',
    submitInstruction: ' Введите HASH вашей транзакции, Вы можете найти идентификатор транзакции в вашем кошельке (Trust Wallet, Metamask и т.д.)',
    availableBalance: 'Доступный баланс',
    choiceNetwork: 'Выберите сеть',
    partnership: 'Партнерский',
    exchangeVideo: 'https://www.youtube.com/embed/O_TP1W1L26c',
  },
  es: {
    oneTokenPrice: 'INSTANT One Token Price',
    withdrawToUSDT: 'Retirar a USDT',
    usdtTotal: 'USDT Total',
    usdtTotalPlaceholder: 'Cuánto USDT desea retirar?',
    FixTotal: 'INSTANT Token Total',
    FixTotalPlaceholder: 'Cuánto quieres retirar de FIX?',
    usdtWallet: 'Billetera USDT',
    usdtWalletPlaceholder: 'Dirección de Su Billetera USDT',
    usdtGetTotal: 'USDT Total que obtendrá',
    usdtGetTotalPlaceholder: 'USDT Total que obtendrá',
    totalWithCommission: 'TOTAL CON COMISIÓN BLOCKCHAIN ​​POR TRANSACCIÓN',
    exchangeUSDToFIX: 'Cambiar USD a INSTANT One Token',
    usdTotal: 'USD Total',
    usdTotalPlaceholder: 'Cuánto USD desea cambiar?',
    totalFIXOneWillGet: 'Total INSTANT One que obtendrás',
    totalFIXOneWillGetPlaceholder: 'INSTANT One Token Total',
    totalWithUSDCommission: 'TOTAL CON 1% DE COMISIÓN',
    exchange: 'Intercambio',
    confirmData: 'Confirma sus Datos',
    confirm: 'Confirmar',
    partnershipTransactions: 'Transacciones de Cuentas de Asociación',
    hoursProceed: 'Su solicitud de retiro se procesará de acuerdo con las reglas durante un máximo de 24 horas',
    partnerName: 'Nombre del Socio',
    userLevel: 'Nivel de Usuario',
    verificationCode: 'Introduzca el código de verificación del correo electrónico',
    enterCode: 'Introduzca el código',
    resendCode: 'reenviar código',
    submitWithdraws: 'Presentar retiradas',
    submitInstruction: 'Introduzca su HASH de transacción Puede encontrar su ID de transacción en su cartera (Trust Wallet, Metamask y etc)',
    availableBalance: 'Saldo disponible',
    choiceNetwork: 'Seleccione la red',
    partnership: 'Cuenta de Asociación',
    exchangeVideo: 'https://www.youtube.com/embed/USQhZAdlTZo',
  }
}
